import { getQuotaInfo, activatedQuota } from '@/api/quota'
import { APPLY_STATUS, USER_STATUS } from './status'
const actions = {
  getQuotaInfo () {
    getQuotaInfo()
  },
  activatedQuota ({ commit, rootState }) {
    if (rootState.user.userInfo.userStatus === USER_STATUS.TMP_QUOTA_CREDIT) {
      return activatedQuota().then(data => {
        commit('SET_QUOTA_INFO', {
          requireBindBankCard: data.needBindCard,
          requireIDCardUpload: data.needIdCardCredit
        })
      })
    } else if (rootState.user.userInfo.userStatus === USER_STATUS.TMP_QUOTA_CREDIT_ING) {
      if (rootState.user.userInfo.applyStatus === APPLY_STATUS.APPLY_OCR_VALID) {
        // 身份证照片上传
        commit('SET_IDCARD_UPLOAD', true)
        return Promise.resolve()
      } else if (rootState.user.userInfo.applyStatus === APPLY_STATUS.APPLY_OCR_VALID_ING) {
        return Promise.reject({
          status: 400,
          message: '身份证照片比对中'
        })
      } else if (rootState.user.userInfo.applyStatus === APPLY_STATUS.APPLY_BANK_VALID) {
        commit('SET_BANK_STATUS', true)
        return Promise.resolve()
      } else {
        return Promise.reject({
          status: 400,
          message:'未处理状态，需要产品确认'
        })
      }
    }
  }
}
const mutations = {
  'SET_QUOTA_INFO' (state, payload) {
    state.amount = payload.amount || 0
    state.date = payload.date || ''
    state.requireIDCardUpload = payload.requireIDCardUpload || false
    state.requireBindBankCard = payload.requireBindBankCard || false
  },
  'SET_IDCARD_UPLOAD' (state, payload) {
    state.requireIDCardUpload = payload
  },
  'SET_BANK_STATUS' (state, payload) {
    state.requireBindBankCard = payload
  },
  'RESET_QUOTA' (state) {
    state.amount = 0
    state.date = ''
    state.requireIDCardUpload = false
    state.requireBindBankCard = false
  }
}
const state = {
  amount: 0,
  date: '',
  requireIDCardUpload: false,
  requireBindBankCard: false
}
export default {
  state,
  mutations,
  actions
}